import React from "react";
import { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Navbar from "../components/navbar";
import { LoadBreakageReports } from "../../../domain/usecases/load-breakage-report";
import { useErrorHandler } from "../hooks";
import { BreakageTable } from "./components/BreakagesTable";
import { LoadProductListByManyCodes } from "../../../domain/usecases/load-product-list-by-many-codes";
import { BreakageReport } from "../../../domain/models/breakage-report";
import { DeleteBreakageReport } from "../../../domain/usecases/delete-brekage-report";
import { UpdateBreakageReport } from "../../../domain/usecases/update-breakage-report";

type Props = {
  loadBrakageReports: LoadBreakageReports;
  loadProducts: LoadProductListByManyCodes;
  deleteBreakage: DeleteBreakageReport;
  updateBreakage: UpdateBreakageReport;
};

export const BreakagePage = ({
  loadBrakageReports,
  loadProducts,
  deleteBreakage,
  updateBreakage,
}: Props) => {
  const [brekages, setBrekages] = useState<BreakageReport[]>([]);
  const handleError = useErrorHandler((error) => {
    alert("Não foi possível carregar os dados");
  });
  useEffect(() => {
    async function fetch() {
      try {
        const warehouseString = localStorage.getItem("currentWarehouse");
        const warehouse = warehouseString
          ? (JSON.parse(warehouseString) as {
              id: number;
              name: string;
            } | null)
          : undefined;
        const data = await loadBrakageReports.load(warehouse!.id, {
          status: "PENDING",
        });
        if (data.length === 0) return;
        const codes = data.map((item) => item.inventory.item.code);
        const products = await loadProducts.load(codes);
        for (const report of data) {
          const match = products.find(
            (product) => product.eanCode === report.inventory.item.code
          );
          if (match) {
            report.inventory.item.description = match.description;
            report.inventory.item.packageAmount = match.packageAmount;
          }
        }

        setBrekages(data);
      } catch (error: any) {
        handleError(error);
      }
    }
    fetch();
  }, []);
  return (
    <>
      <Navbar title="Quebras" />
      <Box
        sx={{
          my: "50px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Container
          sx={{ display: "flex", justifyContent: "space-between", my: "50px" }}
        >
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="pt-br"
          >
            <DatePicker
              slotProps={{ textField: { size: "small" } }}
              //   value={date}
              //   onChange={(newValue) => {
              //     if (newValue) {
              //       setDate(newValue);
              //     }
              //   }}
            />
          </LocalizationProvider>
        </Container>
        <BreakageTable
          data={brekages}
          deleteBreakage={deleteBreakage}
          setBreakages={setBrekages}
          updateBreakage={updateBreakage}
        />
      </Box>
    </>
  );
};
